import { PassedInitialConfig } from 'angular-auth-oidc-client'
import { environment } from '../../environments/environment'

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.oidc.authority,
    redirectUrl: new URL('/oidc/callback/', window.location.origin).toString(),
    postLogoutRedirectUri: new URL('/', window.location.origin).toString(),
    clientId: environment.oidc.clientId,
    scope: 'openid email profile',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: [environment.apiUrl],
    customParamsEndSessionRequest: {
      client_id: environment.oidc.clientId,
      redirect_uri: new URL('/oidc/callback/', window.location.origin).toString(),
      response_type: 'code',
    },
  },
}
